import React, { useState,Suspense, useEffect, lazy } from 'react'
import {Link,NavLink,Navigate,Route} from 'react-router-dom'
import {useKeycloak} from "@react-keycloak/web";
import {
	Space,Switch as SwitchField,Avatar,Menu,Drawer,Button,Breadcrumb,Layout
} from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import systemRoutes from '../routes/SystemRoutes'
import ContentSuspenseComponent from '../components/ContentSuspenseComponent'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next';
import config from "../business/config.json";
import {useAxios} from "../hooks/hooks";
import {cancelTokenSource} from "../hooks/hooks";

const NotFoundPage = lazy(() => import('../pages/NotFoundPage'))
const ErrorPage = lazy(() => import('../pages/ErrorPage'))
const { SubMenu } = Menu;
const {Content} = Layout;

function ORMLayout(props) {
	const axios = useAxios();
	const source = cancelTokenSource;
	const [error,setError] = useState(null);
	const [showList,setShowList] = useState(false);
	const [loaded,setLoaded] = useState(false);
	const [endpoints,setEndpoints] = useState(null);
	const [userProfile,setUserProfile] = useState(null);
	const [drawerVisibility,setDrawerVisibility] = useState(false);
	const [breadcrumbs,setBreadcrumbs] = useState([]);
	const {initialized, keycloak} = useKeycloak();
	const {t} = useTranslation();

	const showDrawer = () => {
    setDrawerVisibility(true);
  };
  const hideDrawer = () => {
    setDrawerVisibility(false);
  };

  const logout = () => {
	  if (initialized) {
		  keycloak.logout().then(r => {});
	  }
  }

	const getEndpoints = async () => {
		try{
			const response = await axios.current.get("/endpoints",
				// {cancelToken: cancelTokenSource.token}
			);
			const data = response.data;
			setUserProfile(data.profile);
			setEndpoints(data.endpoints);
		}catch(e){
			setError(e.message);
		}
		setLoaded(true);
	}

	useEffect(() => {
		console.log("ORM Layout:" + props)
		if (Object.keys(props).includes("location")) {
			var crumbs = props.location.pathname.split("/");
			crumbs.shift();
			const crumbs_len = crumbs.length;
			var bcrumbs = [];
			var link = "/";
			for (var c = 0; c < crumbs_len; c++) {
				link += crumbs[c] + "/";
				bcrumbs.push({
					label: crumbs[c],
					link: link
				});
			}
			setBreadcrumbs(bcrumbs);
		}
	},[props]);

	useEffect(() => {
		getEndpoints();
		return (()=>{
			source.cancel();
		});
  },[]);
	
  return (
		<>
			<Layout className="layout" style={{minHeight:"100vh"}}>
				<Drawer
        	title={
						<Space>
	            <Avatar
  	            key="2"
								size="small" 
    	          icon={<FontAwesomeIcon icon="user"/>} 
      	        style={{marginRight:"0px"}} 
        	      src={(userProfile ? userProfile.avatar_user : "null")}
          	  />
            	<b key="1">
              	{userProfile ? userProfile.first_name_user : ""}
            	</b>
						</Space>
					}
      	  	placement="right"
    	    closable={true}
  	      	onClose={hideDrawer}
			open={drawerVisibility}
	        bodyStyle={{padding:"0px"}}
				>
					<Menu
		        mode="inline" 
		        style={{border:"none"}}
		        defaultOpenKeys={["0"]}
		      >
						{!error && loaded &&
							(Object.keys(userProfile.endpoints).map((e,i) => {
								if(e === "DF") return;
								return (
                <SubMenu 
                  key={i}
                  title={
                    <span>
                      <FontAwesomeIcon 
												icon={userProfile.endpoints[e].icon || "table"} 
												className="fa-fw"
											/> 
                      &nbsp;
                      {t(userProfile.endpoints[e].duty)}
                    </span>
                  }
                >
                  {
							    (Object.keys(userProfile.endpoints[e].namespaces).map((n,j) => (
						  		  <Menu.Item 
											key={"menu-item"+j} 
											icon={
												<FontAwesomeIcon 
													icon={userProfile.endpoints[e].namespaces[n].icon || "table"} 
													className="fa-fw"
												/> 
											}
											style={{
												display:(
													(endpoints[n].list.entity.is_list === false || showList === true)
                        ) ? "block" : "none"
											}}
										>
				    					<NavLink replace={true} to={"/orm/"+userProfile.endpoints[e].namespaces[n].code}>
		    						    &nbsp;{t(userProfile.endpoints[e].namespaces[n].name)}
    									</NavLink>
								    </Menu.Item>
                  )))
                  }
                </SubMenu>
								);
              }))
						}
						{!error && loaded && (
							<>
								<SubMenu
									key="profile-submenu"
									title={
										<span>
											<FontAwesomeIcon 
												icon="user"
												className="fa-fw"
											/>
											&nbsp;
											{t("Profile")}
										</span>
									}
								>
									<Menu.Item
										key="profile-menu-item-1"
										icon={
											<>
												<FontAwesomeIcon icon="stream" className="fa-fw"/> 
												<span>&nbsp;{t('List Links')}</span>
											</>
										}
									>
										<SwitchField
											style={{float:"right",marginTop:"12px"}}
											size="small"
											checked={showList}
											onChange={setShowList}
										/>
									</Menu.Item>
									<Menu.Item
										key="profile-menu-item-2"
										icon={
											<FontAwesomeIcon 
												icon="id-card"
												className="fa-fw"
											/> 
										}
									>
										<NavLink replace={true} to={"/orm/"+t("update-profile")+"/view/"+userProfile.id_user}>
											{t("Update Profile")}
										</NavLink>
									</Menu.Item>
									<Menu.Item
										key="profile-menu-item-3"
										icon={
											<FontAwesomeIcon 
												icon="passport"
												className="fa-fw"
											/> 
										}
									>
										<NavLink replace={true} to={"/orm/"+t("update-password")+"/edit/"+userProfile.id_user}>
											{t("Update Password")}
										</NavLink>
									</Menu.Item>
								</SubMenu>
							</>
						)}
						<Menu.Item
							key="logout-menu-item"
						>
		          <Button type="primary" block icon={<FontAwesomeIcon icon="sign-out-alt" className="fa-fw"/>} onClick={logout}>
               {t('Logout')}
              </Button>
						</Menu.Item>
					</Menu>
				</Drawer>
			  <PageHeader
			    ghost={false}
			    backIcon={
						<Button key="1" icon={
							drawerVisibility ? <FontAwesomeIcon icon="bars"/> : <FontAwesomeIcon icon="bars"/>
						}/>
					}
    			title={
						<Link replace={true} to="/orm" >
							{config.title}
						</Link>
					}
					onBack={showDrawer}
    		/>
				<Content style={{ padding: '0 24px'}}>
					<Breadcrumb style={{ margin: '24px 0' }}>
    	  	  <Breadcrumb.Item>
							<Link to="/orm"><FontAwesomeIcon icon="home"/></Link>
						</Breadcrumb.Item>
						{breadcrumbs.map((breadcrumb,i) => 
    	  	  	<Breadcrumb.Item key={i}>
								<Link to={breadcrumb.link}>{breadcrumb.label}</Link>
							</Breadcrumb.Item>
						)}
					</Breadcrumb>
					<div className="site-layout-content" style={{padding:"24px",background:"white"}}>
						{error && (
              <ErrorPage error={error}/>
						)}
						{loaded && !error && (
							<Suspense fallback={<ContentSuspenseComponent />}>
    	    		   <Navigate>
      	      		 {systemRoutes.map((route, i) => {
        	        	return route.component ? (
		      	           <Route
    	      	       	  key={i}
      	      	   	    exact={true}
        	      	      path={`/orm${route.path}`}
          	     	    	render={(props) => 
													<route.component 
														{...props} 
														home="/orm/"
														endpoints={endpoints} 
														userProfile={userProfile}
													/>
												}
            	     		/>
     	  	         	) : null
      	        	})}
            	  	<Route component={NotFoundPage} />
            		</Navigate>
    	      	</Suspense>
						)}
					</div>
				</Content>
			</Layout>
		</>
  )
}

export default ORMLayout
